<template>
  <component
    :is="as"
    class="relative cursor-pointer group outline-none"
  >
    <svg
      :width="size"
      :height="size"
      viewBox="0 0 50 50"
      x="50%"
      y="50%"
      class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
    >
      <circle
        cx="50%"
        cy="50%"
        r="50%"
        class="fill-primary stroke-white stroke-2 group-hover:fill-black group-focus:fill-black"
        fill-opacity="0.8"
      />
      <path
        d="M35 25L20 33.6603L20 16.3397L35 25Z"
        class="fill-white"
      />
    </svg>
    <slot />
  </component>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'PlayImage',
  props: {
    /**
     * HTML element or component that the overlay is wrapped in. Most common
     * use-case would be to have it as a button
     */
    as: {
      type: String,
      required: false,
      default: 'div',
    },
    /**
     * Size of the play button. Can be a number (treated as pixels) or a percentage.
     *
     * If it's a percentage it scales better but sometimes we want it to be specific.
     */
    size: {
      type: [String, Number],
      required: false,
      default: '50%',
    },
  },
});
</script>
